import { handleActions } from 'redux-actions'

import * as snapshotActions from '../actions/snapshot'

const defaultValue = false

export default handleActions(
  {
    [snapshotActions.onSnapshotProgressStateUpdate.toString()](
      state,
      action: ReturnType<typeof snapshotActions.onSnapshotProgressStateUpdate>
    ) {
      return action.payload
    },
  },
  defaultValue
)
